import {
  CHANGE_ASSIGNEES_ASYNC,
  CLOSE_INCIDENT_ASYNC,
  CLOSE_SAFE_CHALLENGE_INCIDENT_ASYNC,
  DOWNLOAD_ORIGINAL_EMAIL_ASYNC,
  EMAIL_SNAPSHOT_ASYNC,
  FETCH_AFFECTED_MAILBOXES_COUNTS_ASYNC,
  FETCH_ASSIGNEES_ASYNC,
  FETCH_COMMUNITY_INSIGHTS_ASYNC,
  FETCH_SCANS_FREEMIUM_LIMIT_ASYNC,
  KEEP_ENCRYPTED_INCIDENT_IN_QUARANTINE_ASYNC,
  OPEN_EMAIL_SNAPSHOT_NEW_TAB,
  RELEASE_ENCRYPTED_INCIDENT_ASYNC,
  REPORT_ELEMENTS_REQUEST_ASYNC,
  REPORT_ELEMENTS_UPDATE_ASYNC,
  REPORT_REQUEST_ASYNC,
  REPORT_STATE_CHANGE_ASYNC,
  SHOW_AFFECTED_MAILBOXES_VIEW,
  SHOW_SCANNER_DETAILS_VIEW,
  VALIDATE_NEW_AFFECTED_MAILBOXES_SEEN_ASYNC,
  SET_ESCALATED_EMAIL_CARD_TAB_KEY,
} from './constants'

export const fetchReport = (reportId, reportType) => ({
  type: REPORT_REQUEST_ASYNC.INITIATE,
  payload: { reportId, reportType },
})
export const fetchReportSuccess = (data) => ({
  type: REPORT_REQUEST_ASYNC.SUCCESS,
  payload: { data },
})
export const fetchReportError = (error) => ({
  type: REPORT_REQUEST_ASYNC.ERROR,
  error,
})
export const fetchReportCancel = () => ({ type: REPORT_REQUEST_ASYNC.CANCEL })

export const fetchCommunityInsights = (reportId) => ({
  type: FETCH_COMMUNITY_INSIGHTS_ASYNC.INITIATE,
  payload: { reportId },
})
export const fetchCommunityInsightsSuccess = (data) => ({
  type: FETCH_COMMUNITY_INSIGHTS_ASYNC.SUCCESS,
  payload: { data },
})
export const fetchCommunityInsightsError = (error) => ({
  type: FETCH_COMMUNITY_INSIGHTS_ASYNC.ERROR,
  error,
})
export const fetchCommunityInsightsCancel = () => ({
  type: FETCH_COMMUNITY_INSIGHTS_ASYNC.CANCEL,
})

export const changeReportState = (reportId, reportType, newState) => ({
  type: REPORT_STATE_CHANGE_ASYNC.INITIATE,
  payload: { reportId, reportType, newState },
})
const changeReportStateCancel = () => ({
  type: REPORT_STATE_CHANGE_ASYNC.CANCEL,
})
export const changeReportStateSuccess = (data, newState, reportType) => ({
  type: REPORT_STATE_CHANGE_ASYNC.SUCCESS,
  payload: { data, newState, reportType },
})
export const changeReportStateError = (error) => ({
  type: REPORT_STATE_CHANGE_ASYNC.ERROR,
  error,
})

const updateElements = (reportId, reportType, elementsName) => ({
  type: REPORT_ELEMENTS_UPDATE_ASYNC.INITIATE,
  payload: { reportId, reportType, elementsName },
})
const updateElementsCancel = () => ({
  type: REPORT_ELEMENTS_UPDATE_ASYNC.CANCEL,
})
export const updateElementsSuccess = (data) => ({
  type: REPORT_ELEMENTS_UPDATE_ASYNC.SUCCESS,
  payload: { data },
})
export const updateElementsError = (error) => ({
  type: REPORT_ELEMENTS_UPDATE_ASYNC.ERROR,
  error,
})

const fetchElements = (reportId, reportType, elementsName) => ({
  type: REPORT_ELEMENTS_REQUEST_ASYNC.INITIATE,
  payload: { reportId, reportType, elementsName },
})
const fetchElementsCancel = () => ({
  type: REPORT_ELEMENTS_REQUEST_ASYNC.CANCEL,
})
export const fetchElementsSuccess = (data, reportId, elementsName) => ({
  type: REPORT_ELEMENTS_REQUEST_ASYNC.SUCCESS,
  payload: { data, reportId, elementsName },
})
export const fetchElementsError = (error) => ({
  type: REPORT_ELEMENTS_REQUEST_ASYNC.ERROR,
  error,
})

const validateNewAffectedMailboxesSeen = () => ({
  type: VALIDATE_NEW_AFFECTED_MAILBOXES_SEEN_ASYNC.INITIATE,
})
export const validateNewAffectedMailboxesSeenSuccess = () => ({
  type: VALIDATE_NEW_AFFECTED_MAILBOXES_SEEN_ASYNC.SUCCESS,
})
export const validateNewAffectedMailboxesSeenError = (error) => ({
  type: VALIDATE_NEW_AFFECTED_MAILBOXES_SEEN_ASYNC.ERROR,
  error,
})

const fetchAffMailboxesCounts = (reportId) => ({
  type: FETCH_AFFECTED_MAILBOXES_COUNTS_ASYNC.INITIATE,
  payload: { reportId },
})
export const fetchAffMailboxesCountsSuccess = (data) => ({
  type: FETCH_AFFECTED_MAILBOXES_COUNTS_ASYNC.SUCCESS,
  payload: { data },
})
export const fetchAffMailboxesCountsError = (error) => ({
  type: FETCH_AFFECTED_MAILBOXES_COUNTS_ASYNC.ERROR,
  error,
})

export const fetchAssignees = (search) => ({
  type: FETCH_ASSIGNEES_ASYNC.INITIATE,
  payload: { search },
})
export const fetchAssigneesSuccess = (data) => ({
  type: FETCH_ASSIGNEES_ASYNC.SUCCESS,
  payload: { data },
})
export const fetchAssigneesError = (error) => ({
  type: FETCH_ASSIGNEES_ASYNC.ERROR,
  error,
})
export const fetchAssigneesCancel = (error) => ({
  type: FETCH_ASSIGNEES_ASYNC.CANCEL,
  error,
})

const changeAssignees = (reportId, reportType, assigneeId) => ({
  type: CHANGE_ASSIGNEES_ASYNC.INITIATE,
  payload: { reportId, reportType, assigneeId },
})
export const changeAssigneesSuccess = (data) => ({
  type: CHANGE_ASSIGNEES_ASYNC.SUCCESS,
  payload: { data },
})
export const changeAssigneesError = (error) => ({
  type: CHANGE_ASSIGNEES_ASYNC.ERROR,
  error,
})
export const changeAssigneesCancel = (error) => ({
  type: CHANGE_ASSIGNEES_ASYNC.CANCEL,
  error,
})

const fetchScansFreemiumLimit = () => ({
  type: FETCH_SCANS_FREEMIUM_LIMIT_ASYNC.INITIATE,
})
export const fetchScansFreemiumLimitSuccess = (data) => ({
  type: FETCH_SCANS_FREEMIUM_LIMIT_ASYNC.SUCCESS,
  payload: { data },
})
export const fetchScansFreemiumLimitError = (error) => ({
  type: FETCH_SCANS_FREEMIUM_LIMIT_ASYNC.ERROR,
  error,
})

const downloadOriginalEmail = (reportId, emailType) => ({
  type: DOWNLOAD_ORIGINAL_EMAIL_ASYNC.INITIATE,
  payload: { reportId, emailType },
})
export const downloadOriginalEmailSuccess = (data) => ({
  type: DOWNLOAD_ORIGINAL_EMAIL_ASYNC.SUCCESS,
  payload: { data },
})
export const downloadOriginalEmailError = (error, id) => ({
  type: DOWNLOAD_ORIGINAL_EMAIL_ASYNC.ERROR,
  payload: {
    error,
    id,
  },
})

export const showScannerDetailsView = (data) => ({
  type: SHOW_SCANNER_DETAILS_VIEW,
  payload: { data },
})
export const showAffMailboxesView = (data) => ({
  type: SHOW_AFFECTED_MAILBOXES_VIEW,
  payload: { data },
})

const closeIncident = (reportId) => ({
  type: CLOSE_INCIDENT_ASYNC.INITIATE,
  payload: { reportId },
})
export const closeIncidentSuccess = (data) => ({
  type: CLOSE_INCIDENT_ASYNC.SUCCESS,
  payload: { data },
})
export const closeIncidentError = (error) => ({
  type: CLOSE_INCIDENT_ASYNC.ERROR,
  error,
})

const closeSafeChallengeIncident = (reportId) => ({
  type: CLOSE_SAFE_CHALLENGE_INCIDENT_ASYNC.INITIATE,
  payload: { reportId },
})
export const closeSafeChallengeSuccess = (data) => ({
  type: CLOSE_SAFE_CHALLENGE_INCIDENT_ASYNC.SUCCESS,
  payload: { data },
})
export const closeSafeChallengeError = (error) => ({
  type: CLOSE_SAFE_CHALLENGE_INCIDENT_ASYNC.ERROR,
  error,
})

const releaseEncryptedIncident = (reportId) => ({
  type: RELEASE_ENCRYPTED_INCIDENT_ASYNC.INITIATE,
  payload: { reportId },
})
export const releaseEncryptedIncidentSuccess = (data) => ({
  type: RELEASE_ENCRYPTED_INCIDENT_ASYNC.SUCCESS,
  payload: { data },
})
export const releaseEncryptedIncidentError = (error) => ({
  type: RELEASE_ENCRYPTED_INCIDENT_ASYNC.ERROR,
  error,
})

const keepEncryptedIncidentInQuarantine = (reportId) => ({
  type: KEEP_ENCRYPTED_INCIDENT_IN_QUARANTINE_ASYNC.INITIATE,
  payload: { reportId },
})
export const keepEncryptedIncidentInQuarantineSuccess = (data) => ({
  type: KEEP_ENCRYPTED_INCIDENT_IN_QUARANTINE_ASYNC.SUCCESS,
  payload: { data },
})
export const keepEncryptedIncidentInQuarantineError = (error) => ({
  type: KEEP_ENCRYPTED_INCIDENT_IN_QUARANTINE_ASYNC.ERROR,
  error,
})
const fetchEmailSnapshot = (reportId) => ({
  type: EMAIL_SNAPSHOT_ASYNC.INITIATE,
  payload: { reportId },
})
export const fetchEmailSnapshotSuccess = (data) => ({
  type: EMAIL_SNAPSHOT_ASYNC.SUCCESS,
  payload: data.emailBodyPreviewUrl,
})
export const fetchEmailSnapshotError = (error) => ({
  type: EMAIL_SNAPSHOT_ASYNC.ERROR,
  error,
})

const openEmailSnapshot = (reportId) => ({
  type: OPEN_EMAIL_SNAPSHOT_NEW_TAB,
  payload: { reportId },
})

const setEscalatedEmailCardTabKey = (key) => ({
  type: SET_ESCALATED_EMAIL_CARD_TAB_KEY,
  payload: { key },
})

export default {
  // to props
  fetchReport,
  fetchAssignees,
  changeAssignees,
  fetchReportCancel,
  changeReportState,
  fetchCommunityInsights,
  fetchCommunityInsightsCancel,
  changeReportStateCancel,
  updateElements,
  updateElementsCancel,
  fetchElements,
  fetchElementsCancel,
  showScannerDetailsView,
  showAffMailboxesView,
  validateNewAffectedMailboxesSeen,
  fetchAffMailboxesCounts,
  fetchScansFreemiumLimit,
  downloadOriginalEmail,
  closeIncident,
  closeSafeChallengeIncident,
  releaseEncryptedIncident,
  keepEncryptedIncidentInQuarantine,
  fetchEmailSnapshot,
  openEmailSnapshot,
  setEscalatedEmailCardTabKey,
}
